<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Visit of Officers to the Club</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date of Visit*'"
              v-model="form.date"
              :setectVale="form.date"
              @changeInput="form.date = $event"
            ></DatePicker>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-select
              v-model="form.member_id"
              :items="firstGovernor"
              :item-text="'name'"
              :item-value="'uuid'"
              label="Vice Governor I"
              dense
              clearable
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-select
              v-model="form.member_id_two"
              :items="secondGovernor"
              :item-text="'name'"
              :item-value="'uuid'"
              label="Vice Governor II"
              dense
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.is_before_date"
              label="Is submit before end of December"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of attendance"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Photo"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.member_id"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { CommonService } from "../../../services/common-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    projects: [],
    form: {
      name: "",
      is_before_date: 0,
      date: null,
      member_id: "",
      member_id_two: "",
    },
    firstGovernor: [],
    secondGovernor: [],
  }),

  mounted() {
    this.getOfficersByRoleFirst();
    this.getOfficersByRoleSecond();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      this.form.month = this.$route.params.month;

      let fd = new FormData();

      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append("member_id_two", this.form.member_id_two);
      fd.append("date", this.form.date);
      fd.append("member_id", this.form.member_id);
      fd.append("is_before_date", this.form.is_before_date == null ? 0 : this.form.is_before_date);

      fd.append("month", this.$route.params.month);
      fd.append("key", "VICE_GOVERNOR_VISITS");
      let data = fd;
      ActivityService.submitCommonActivity(data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getOfficersByRoleFirst() {
      CommonService.getMembersByOfficeRoleCode("FIRST_VICE_DISTRICT_GOVERNOR")
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.firstGovernor = response.data.data;
          }
        })
        .catch((error) => {
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.firstGovernor = [];
        });
    },

    getOfficersByRoleSecond() {
      CommonService.getMembersByOfficeRoleCode("SECOND_VICE_DISTRICT_GOVERNOR")
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.secondGovernor = response.data.data;
          }
        })
        .catch((error) => {
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.secondGovernor = [];
        });
    },

    changeExtensionChairman(value) {
      this.form.extension_chairman = value;
    },

    changeAdviserLion1(value) {
      this.form.adviser_lion_1 = value;
    },

    changeAdviserLion2(value) {
      this.form.adviser_lion_2 = value;
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
